/**
 * Vendor-neutral feature-flag API. The shell-owned Unleash integration sits behind this boundary
 * (Atlas ADR-0028).
 */
export { REGARD_INTERNAL_CUSTOMER } from './flagContext'
export type { FlagIdentity } from './flagContext'
export type { FlagName, SuiteFlagName } from './flagNames'
export { useFlag } from './useFlag'
export { useSessionFlags } from './useSessionFlags'
